import { AxiosResponse } from "axios";

export class FetchConfigurationByNameResData {
    enumEntryList: Array<{ id: number; label: string }>;

    constructor(response: AxiosResponse) {
        if (response.data) {
            this.parse(response.data);
        }
    }

    public parse(obj: any) {
        if (obj) {
            this.enumEntryList = new Array<{ id: number; label: string }>();
            obj.forEach((element) => {
                this.enumEntryList.push({ id: element.id, label: element.label });
            });
        }
    }
}
